const options = {
    Toolbar: {
      display: {
        left: ["infobar"],        
        right: ["close"],
      },
    },
  video: {
    autoStart: false
}
};
Fancybox.bind("[data-fancybox='gallery']", options);
$('body').on('click','.pdp-item .pdp-img',function(){
  Fancybox.bind("[data-fancybox='gallery']", options);
});